import axios from 'axios'
import { CONFIGS } from '../configs'

export default {
  list(page, search) {
    if(page === undefined) page = 1
    if(search === undefined || search==='') search = ''; else search = '&search='+search
    return axios.get(CONFIGS.API_SERVER + '/profile/?ordering=-id&page='+page+search)
  },
  get(id) {
    return axios.get(CONFIGS.API_SERVER + '/profile/' + id)
  },
  get_staffs() {
    return axios.get(CONFIGS.API_SERVER + '/api/user/users_admins/')
  },
  create(data) {
    return axios.post(CONFIGS.API_SERVER + '/profile/', data)
  },
  get_addresses(data) {
    //{
    // 	"users": "32,24,10,26,27,28,29,30",
    // 	"type": "simple"
    // }
    return axios.post(CONFIGS.API_SERVER + '/api/user/users_addresses_list/', data)
  },
  update(data, id) {
    return axios.put(CONFIGS.API_SERVER + '/profile/' + id + '/', data)
  },
  remove(id) {
    return axios.delete(CONFIGS.API_SERVER + '/profile/' + id)
  }
}
